"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 *  Responsive Settings
 *    Settings that match the SCSS responsive settings
 *
 *
 *  Version:
 *    1.0.1 - 2019/12/01
 */
var xsmall = exports.xsmall = 350;
var small = exports.small = 750;
var medium = exports.medium = 1100;
var large = exports.large = 1350;
var xlarge = exports.xlarge = 1650;
var xxlarge = exports.xxlarge = 2000;